export const userColorByStatus: Record<UserStatus, string> = {
    working: "var(--jade-9)",
    unavailable: "var(--tomato-9)",
}

export const objectColorByStatus: Record<ObjectStatus, string> = {
    expired: "var(--tomato-9)",
    "past due": "var(--tomato-9)",

    unconverted: "var(--orange-9)",
    uninvoiced: "var(--orange-9)",
    unestimated: "var(--orange-9)",
    unpaid: "var(--orange-9)",
    review: "var(--orange-9)",
    "needs review": "var(--orange-9)",

    "overdue one to fifteen": "var(--tomato-7)",

    "overdue sixteen to thirty": "var(--tomato-8)",

    "overdue more than thirty": "var(--tomato-9)",

    active: "var(--jade-9)",

    "on hold": "var(--orange-11)",

    "internal on hold": "var(--gray-12)",
    "internal on hold substatus": "var(--gray-12)",
    "external on hold substatus": "var(--gray-12)",

    sent: "var(--blue-9)",
    "awaiting approval": "var(--blue-9)",
    upcoming: "var(--blue-9)",
    "overdue undefined": "var(--blue-9)",

    acknowledged: "var(--blue-11)",

    "in transit": "var(--cyan-9)",

    draft: "var(--gray-8)",
    lost: "var(--gray-8)",
    jobbed: "var(--gray-8)",
    invoiced: "var(--gray-8)",
    confirmed: "var(--gray-8)",
    cancelled: "var(--gray-8)",

    "quick paused": "var(--amber-9)",
    unstocked: "var(--amber-9)",
    lunch: "var(--amber-9)",

    unsent: "var(--violet-9)",
    unscheduled: "var(--violet-9)",

    "jobs on hold": "var(--orange-11)",

    "jobs on hold internal": "var(--amber-11)",

    "jobs on hold external": "var(--gray-12)",
}
